<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card color="blue">
          <v-card-title flat class='white--text subheading'>{{ 'PEERGROUP_TITLE_SAVE' | translate}}</v-card-title>
        </v-card>
        <!--<v-card-title>
          <span class="headline">{{ 'SEARCH_MASK_NAME' | translate}}</span>
        </v-card-title>-->
        <v-card-text>
          <v-layout wrap>
            <v-flex class="mt-4">
              <v-text-field  solo v-model="maskName" :label="Searchmaskname" required clearable></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="mx-2">

          <v-btn color="#004884" small outline dark class="text-none" @click.native="cancelItem">{{ 'BUTT_CANCEL' | translate}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#004884" small dark class="text-none" @click.native="doItem">{{ 'BUTT_SAVE' | translate}}</v-btn>

          <!--<v-btn color="blue darken-1" flat @click.native="dialogSearchField = false">{{ 'BUTT_CANCEL' |
            translate}}
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="saveMask">{{ 'BUTT_SAVE' | translate}}</v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'DialogSaveItem',
  components: {},
  methods: {
    open: function (item) {
      this.dialog = true
      this.item = item
    },
    cancelItem: function () {
      this.dialog = false
      this.$emit('cancelItem', this.item)
    },
    doItem: function () {
      this.dialog = false
      this.$emit('doItem', {name: this.maskName})
    }
  },
  data () {
    return {
      dialog: false,
      maskName: '',
      item: {},
      Searchmaskname: Vue.i18n.translate('LABEL_PEERGROUPNAME')
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/module/dialogs/DialogSaveItem.vue